import { Component, OnInit } from '@angular/core';
import { DashboardService } from 'src/app/service/events/dashboard.service';
import { BaseView } from 'src/app/view/base-view';
import { CitasApiService } from 'src/app/service/api/citas-api.service';
import { environment } from 'src/environments/environment';
import { VisitasApiService } from 'src/app/service/api/visitas-api.service';
import { Router } from '@angular/router';
import { RequestButtonTypes } from 'src/app/common/components/request-button/request-button.component';
import { RequestHandler } from 'src/app/service/OffService/request-handler';
import moment from 'moment';
import { Filtering } from 'src/app/service/filtering/filtering';

import { VisitasSemanaModel } from 'src/app/models/visitas/visitas-semana.model';
import { ColInterface } from 'src/app/common/components/common-list-table/col.interface';
import { ColStylesInterface } from 'src/app/common/components/common-list-table/col-styles.interface';
import { TreeNode } from 'primeng/api';

import { FormType } from '@fitogest/reactive-form-builder/interfaces';
import { VisitasSemanaFormDefinition } from './visitas-semana-form/form-control/form-definition';
@Component({
    selector: 'app-visitas-semana',
    standalone: false,
    templateUrl: './visitas-semana.component.html',
    styleUrls: ['./visitas-semana.component.scss']
})
export class VisitasSemanaComponent extends BaseView<VisitasSemanaModel> implements OnInit {
    public form: VisitasSemanaFormDefinition | null = null;
    public serverUrl = environment.serverUrl;


    public fincaName = environment.features.fincaName;
    public parcelaName = environment.features.parcelaName;
    public fincasName = environment.features.fincasName;

    public deleteRequest: RequestHandler<VisitasSemanaModel> = this.visitasApi.visitasSemanaDELETE;
    public deleteRequestButtonType: RequestButtonTypes = RequestButtonTypes.DELETE;
    public getRequest = this.citasApi.visitasSemanaGET;
    public menuItemId = 'visitas-semana';
    public override filtering: Filtering<VisitasSemanaModel> = new Filtering<VisitasSemanaModel>();

    public plagas: string[] = [];

    public currentWeek: {name: string, value: number | null} = {name: 'TODAS', value: null};
    public currentYear: {name: string, value: number | null} = {name: 'TODOS', value: null};
    public weeks: {name: string, value: number | null}[] = [];
    public years: {name: string, value: number | null}[] = [];

    public cols: ColInterface[] = [];

    constructor(
        private router: Router,
        private dashboard: DashboardService,
        private citasApi: CitasApiService,
        private visitasApi: VisitasApiService
    ) {
        super(dashboard, citasApi.visitasSemanaGET, visitasApi.visitasSemanaDELETE);

        const year1 = parseInt(moment().subtract(1, 'year').format('YYYY'), 10);
        const year10 = parseInt(moment().add(9, 'years').format('YYYY'), 10);

        this.weeks.push({name: 'TODAS', value: null});
        this.years.push({name: 'TODOS', value: null});

        for (let i = 1; i <= 54; i++) {
            this.weeks.push( {name: i.toString(), value: i} );
        }
        for (let i = year1; i <= year10; i++) {
            this.years.push( {name: i.toString(), value: i} );
        }
    }


    public override show(modal: string, data: VisitasSemanaModel): void {
        super.show(modal, data);
        this.setModalForm(modal);
    }

    ngOnInit() {
        this.dashboard.setMenuItem(this.menuItemId);

        this.filtering.addFilter((copy: TreeNode<VisitasSemanaModel>[] | void) => {
            return (copy as TreeNode<VisitasSemanaModel>[]).filter(row => {
                const visita = row as unknown as VisitasSemanaModel;

                const weekCond = this.currentWeek.value
                    ? visita?.semana?.toString() === this.currentWeek.value.toString()
                    : true;
                const yearCond = this.currentYear.value
                    ? visita?.ano?.toString() === this.currentYear.value.toString()
                    : true;
                return weekCond && yearCond;
            });
        });

        this.visitasApi.visitasPLAGAS_GET.toPromise()
            .then(plagas => {
                this.plagas = (plagas || []).map((it: VisitasSemanaModel) => it.plaga1 ?? '');
                
                this.getRequest.response(() => {
                    this.formatTable();
                });
                
                this.getRequest.perform();
                
                return;
            }).catch (e => {
                console.log('catch en getPosition: ' + e);
            });
    }

    public filterValues() {
        this.filtering.filter();
    }

    public globalConditionalStyle(_value: string, cell: ColInterface): ColStylesInterface {
        if (!['finca_nombre', 'parcela_nombre', 'ano'].includes(cell.field)) {
            return {
                textAlign: 'center'
            };
        } else {
            return {};
        }
    }

    public globalVisualTransform(value: string, col: ColInterface, row: TreeNode<VisitasSemanaModel>): string {
        const visita = row.data as VisitasSemanaModel;

        if (['finca_nombre', 'parcela_nombre', 'semana', 'ano'].includes(col.field)) {
            return value;
        }

        for (const i of [1, 2, 3, 4, 5, 6]) {
            if (visita['plaga' + i] && (col.field === visita['plaga' + i])) {
                return '×';
            }
        }

        return '';
    }

    public formatTable() {
        if (this.plagas && this.getRequest.value) {
            this.cols = [
                {field: 'finca_nombre', header: this.fincaName},
                {field: 'parcela_nombre', header: this.parcelaName},
                {field: 'semana', header: 'Semana'},
            ];

            this.plagas.forEach(plaga => {
                this.cols.push({
                    field: plaga,
                    header: plaga
                });
            });
  
            this.filterValues();
        }
    }

    public edit(data: VisitasSemanaModel) {
        this.router.navigate(['dashboard', 'editar-visita-semana', data.id]);
    }

    private setModalForm(modal: string): void {
        if (modal !== 'info' && modal !== 'delete') {
            return;
        }

        const formType = modal === 'delete' ? FormType.DELETION : FormType.INFORMATIVE;

        this.form = new VisitasSemanaFormDefinition(formType, this.model, undefined);
    }

}
